import axiosInstance from '../../common/axios.service';
const API_URL = 'employee/login';
import {LOGIN_PAYLOAD} from './auth.type';
import {localStorageKey} from '../../utils/localStoraegUtils';

const login = ({username, password}: LOGIN_PAYLOAD) => {
  return axiosInstance
    .post(API_URL, {
      username,
      password,
    })
    .then((response) => {
      if (response.data.token) {
        localStorage.setItem(localStorageKey, JSON.stringify(response.data));
      }

      return response;
    });
};

const logout = () => {
  localStorage.removeItem(localStorageKey);
};

const authService = {
  login,
  logout,
};

export default authService;
